import React from 'react'
import { Check, Clock, EyeIcon, TriangleExclamation } from '../../../../components/icons/Icons'
import { Col, Row } from 'react-bootstrap'

const Card = () => {
    return (
        <Row className='mt-5'>
            <Col sm="6">
                <div className='emp-tds-card'>

                    <h3 className='color-white mb-3'>Tax Declaration Status</h3>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-white'>Declaration</span> <span className='badge-green '><Check /> Submitted</span>
                    </div>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-white'>Proof Status</span> <span className='badge-yellow'> <TriangleExclamation /> Pending </span>
                    </div>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-2'>
                        <span className='color-white'>HR Verification</span> <span className='badge-purple'> <EyeIcon /> In Review </span>
                    </div>

                    <div className='d-flex align-items-center justify-content-between gap-2'>
                        <span className='color-white'>Final Approval</span> <span className='badge-gray'> <Clock /> Pending </span>
                    </div>

                </div>
            </Col>
            <Col sm="6">
                <div className='emp-tds-card'>

                    <h3 className='color-white mb-4'>Quick Financial Summary</h3>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                        <span className='color-white'>Total Declared</span> <span className='color-white'> ₹ 2,45,000</span>
                    </div>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                        <span className='color-white'>Total Allowed</span> <span className='green-text'> ₹2,30,000 </span>
                    </div>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                        <span className='color-white'>Tax Savings</span> <span className='text-purple'> ₹71,500</span>
                    </div>
                    <hr className='color-gray' />
                    <div className='d-flex align-items-center justify-content-between gap-2'>
                        <span className='color-white'>Final Taxable Income</span> <span className='color-white'> ₹8,70,000 </span>
                    </div>

                </div>
            </Col>
            <Col sm="12">
                <div className='emp-tds-card mt-3 mb-3'>

                    <h3 className='color-white mb-4'>Important Dates</h3>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                        <span className='color-white'>Declaration Deadline</span> <span className='text-red'> 31st Dec 2024</span>
                    </div>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                        <span className='color-white'>Proof Submission</span> <span className='yellow-text'> 31st Dec 2024 </span>
                    </div>

                    <div className='d-flex align-items-center justify-content-between gap-2 mb-3'>
                        <span className='color-white'>Form 16 Release</span> <span className='text-gray'> 15th May 2025</span>
                    </div>
                   
                </div>
            </Col>
        </Row>

    )
}

export default Card